import React from 'react';
import IconComponent from 'ui/src/components/Icon';
import ImageComponent from 'ui/src/components/Image';
import twMerge from 'utilities/src/twMerge';

type Props = {
  className?: string;
};

function VerifiedTopTalentBadge({ className }: Props) {
  return (
    <div className={twMerge('absolute -top-3 right-6 z-10', className)}>
      <div className="relative">
        <ImageComponent
          src="https://assets.bairesdev.com/image/upload/www/static/Badge_rpa58s.svg"
          alt=""
          role="presentation"
          width={134}
          height={40}
        />
        <div className="absolute inset-0 flex items-center justify-center pl-1">
          <div className="flex items-center gap-1">
            <div className="mb-1 flex h-3 w-3 items-center justify-center">
              <IconComponent iconName="VerifiedUser" size="IconS" className="bg-site-neutrals-0" />
            </div>
            <span className="text-site-neutrals-0 whitespace-nowrap text-[0.6875rem] font-medium">
              Verified Top Talent
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifiedTopTalentBadge;
